import { PDFDocument } from 'pdf-lib';

export const addHeaderFooterToPDF = async (pdfBlob, headerImage, footerImage, company,fileName) => {
  try {
    // Load the PDF document from the Blob
    const pdfDoc = await PDFDocument.load(await pdfBlob.arrayBuffer());

    let headerDims = ''
    // Embed the header and footer images
    const headerImageBytes = await fetch(headerImage).then(res => res.arrayBuffer());
    const headerImageEmbed = await pdfDoc.embedPng(headerImageBytes);
    headerDims = headerImageEmbed.scale(0.35); // Adjust scaling as needed

    if (company === 'Samde') {
      headerDims = headerImageEmbed.scale(0.45)
    }
    

    let footerDims = ''
    let footerImageEmbed = ''

    if (company !== 'Samde') {
      const footerImageBytes = await fetch(footerImage).then(res => res.arrayBuffer());
      footerImageEmbed = await pdfDoc.embedPng(footerImageBytes);
      footerDims = footerImageEmbed.scale(0.33);
    }

    if (company === 'Petrose') {
      headerDims = headerImageEmbed.scale(0.5)
      footerDims = footerImageEmbed.scale(0.5);

    }

    // Get the dimensions of the images

    // Add header and footer to each page
    const pages = pdfDoc.getPages();
    pages.forEach(page => {
      const { width, height } = page.getSize();

      // Header at the top center
      page.drawImage(headerImageEmbed, {
        x: width / 2 - headerDims.width / 2,
        y: height - headerDims.height - 10, // Adjust y-position as needed
        width: headerDims.width,
        height: headerDims.height,
      });

      if (company !== 'Samde') {

        // Footer at the bottom center
        page.drawImage(footerImageEmbed, {
          x: width / 2 - footerDims.width / 2,
          y: 10, // Adjust y-position as needed
          width: footerDims.width,
          height: footerDims.height,
        });

      }

    });

    // Serialize the PDF to bytes
    const pdfBytes = await pdfDoc.save();

    // Create a Blob from the PDF bytes and download the file
    const updatedPdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(updatedPdfBlob);
    link.download = `${fileName}.pdf`;
    link.click();

    console.log('PDF with header and footer generated and downloaded.');
  } catch (error) {
    console.error('Error adding header and footer to PDF:', error);
  }
};